import store from '@/store';
import {
  GridItemResponse,
  RailItemResponse,
  RailResponse,
  SeriesResponse,
  VideoResponse,
} from '@/types/cms';


export type CacheableCMSItem = RailItemResponse | GridItemResponse;

export function cacheCMSItems(items: CacheableCMSItem[]) {
  const videos: VideoResponse[] = [];
  const series: SeriesResponse[] = [];

  items.forEach((item) => {
    if (item.type === 'VIDEO') {
      videos.push(item.video);
    } else if (item.type === 'SERIES') {
      series.push(item.series);
    }
  });

  store.commit('CACHE_CONTENT', { videos, series });
}

/** The same for a set of rails, whose `items` the API can leave out. */
export function cacheRailContent(rails: RailResponse[]) {
  cacheCMSItems(rails.flatMap((rail) => rail.items ?? []));
}
